import { trans } from '@/i18n';
import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const AccountPageMenu = () => {
  const menulist = [
    {
      url: '/order-history',
      name: trans('Order History'),
    },
    {
      url: '/my-showroom',
      name: trans('My Showroom'),
    },
    {
      url: '/important-dates',
      name: trans('Important Dates'),
    },
    {
      url: '/address-book',
      name: trans('Address Book'),
    },
    {
      url: '/account-information',
      name: trans('Account Details'),
    },
    {
      url: '/account-influencer',
      name: trans('Influencer Program'),
    },
    {
      url: '/product-reviews',
      name: trans('Product Reviews'),
    },
    {
      url: '/communications',
      name: trans('Newsletter Subscriptions'),
    },
  ];

  const pathname = usePathname();

  return (
    <>
      <Link
        className='text-xs leading-4 lg_hidden'
        href='/my-account'
      >
        {'<'} {trans('Account')}
      </Link>
      <div className=' hidden w-[270px] flex-none flex-col gap-y-[25px] pt-[60px] lg_flex'>
        {menulist.map((item, index) => (
          <Link
            className={clsx(
              ' text-base leading-5 ',
              'lg_hover_underline',
              pathname === item.url ? 'font-medium underline' : '',
            )}
            key={index}
            href={item.url}
          >
            {item.name}
          </Link>
        ))}
      </div>
    </>
  );
};

export default AccountPageMenu;
